import React, { useState, useEffect } from "react";
import "../styles/Formularios.css";
import "../styles/TablaPermisos.css";
import { useGlobal } from "../context/ContenedorGlobal";
import InputGenerico from "./InputGenerico";
import InputSelectGenerico from "./InputSelectGenerico";
import InputSelectEstados from "./InputSelectEstados";
import { useApiFetch } from "../utils/apiFetch";


function ModificarTecnicos() {

    const { permisos, setModuloActual, setSubModuloActual, tecnicoSeleccionado, setTecnicoSeleccionado, logout } = useGlobal();
    const [idTecnico, setIdTecnico] = useState("");
    const [datosTecnico, setDatosTecnico] = useState(null);
    const [modificarPermisos, setModificarPermisos] = useState(false);
    const [permisosDisponibles, setPermisosDisponibles] = useState([]);
    const [permisosSeleccionados, setPermisosSeleccionados] = useState([]);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);
    const [rolOriginal, setRolOriginal] = useState(null);
    const apiFetch = useApiFetch();
    const tienePermisoModificar = permisos.includes(7); // id_permiso=7 "Modificar Técnicos"
    const [tabActiva, setTabActiva] = useState(0);
    const rolCambio = rolOriginal && datosTecnico && datosTecnico.id_rol !== rolOriginal;

    // Buscar técnico manualmente
    const handleBuscar = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");
        setLoading(true);

        try {

            const data = await apiFetch("consultar_tecnico_especifico.php?id_tecnico=" + idTecnico, {
                method: "POST",
                headers: { "Content-Type": "application/json" }
            }, logout);

            if (data.status === "ok" && data.data) {
                setDatosTecnico(data.data);
                setRolOriginal(data.data.id_rol);
            } else {
                setError(data.message || "Técnico no encontrado.");
                setTimeout(() => {
                    setModuloActual("Control");
                    setSubModuloActual(null);
                }, 3000);
            }
        } catch {
            setError("Error de conexión con el servidor.");
        } finally {
            setLoading(false);
        }
    };

    // Cargar técnico automáticamente si viene desde ConsultarTecnicos.jsx
    useEffect(() => {
        if (tecnicoSeleccionado) {
            const cargarTecnico = async () => {
                try {
                    const data = await apiFetch("consultar_tecnico_especifico.php?id_tecnico=" + tecnicoSeleccionado, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" }
                    }, logout);

                    if (data.status === "ok" && data.data) {
                        setDatosTecnico(data.data);
                        setRolOriginal(data.data.id_rol);
                    } else {
                        setError(data.message || "Técnico no encontrado.");
                    }
                } catch {
                    setError("Error al cargar técnico.");
                }
            };

            cargarTecnico();
        }
    }, [tecnicoSeleccionado]);

    // Cargar permisos si se activa el radiobutton
    useEffect(() => {

        if (modificarPermisos && datosTecnico) {
            const cargarPermisos = async () => {
                try {
                    const data = await apiFetch("consulta_permisos_tecnico.php", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            id_tecnico: datosTecnico.id_tecnico,
                            id_permiso: 7
                        })
                    }, logout);

                    if (data.status === "ok") {
                        setPermisosDisponibles(data.permisos || []);
                        setPermisosSeleccionados(data.permisosSeleccionados || []);
                    }
                } catch {
                    setError("Error al cargar permisos.");
                }
            };

            cargarPermisos();
        }
    }, [modificarPermisos, datosTecnico]);

    // Modificar técnico
    const handleModificar = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");
        setLoading(true);

        try {
            const payload = {
                id_tecnico: datosTecnico.id_tecnico,
                id_rol: datosTecnico.id_rol,
                id_estado: datosTecnico.id_estado,
                id_permiso: 7
            };

            if (modificarPermisos) {
                payload.permisos = permisosSeleccionados;
            }

            const data = await apiFetch("modificar_tecnicos.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            }, logout);

            if (data.status === "ok") {
                setSuccess("\u2705 Técnico modificado correctamente.");
            } else {
                setError(data.message || "Error al modificar técnico.");
            }

            setTimeout(() => {
                setModuloActual("Control");
                setSubModuloActual(null);
                setTecnicoSeleccionado(null);
                setLoading(false);
            }, 3000);

        } catch {
            setError("Error de conexión con el servidor.");
            setTimeout(() => {
                setModuloActual("Control");
                setSubModuloActual(null);
                setTecnicoSeleccionado(null);
                setLoading(false);
            }, 3000);
        }
    };

    if (!tienePermisoModificar) {
        return <p>Acceso denegado. No tiene permiso para modificar técnicos.</p>;
    }

    // Cancelar y volver a la vista anterior
    const handleCancelar = () => {
        // Limpia estados si lo deseas
        setDatosTecnico(null);
        setIdTecnico("");
        setError("");
        setSuccess("");

        // Regresa al módulo anterior
        setModuloActual("Control");
        setSubModuloActual("Consultar Técnicos");
    };

    return (
        <>
            {!datosTecnico && !tecnicoSeleccionado && (
                <div className="sesion-form">
                    <form onSubmit={handleBuscar}>
                        <InputGenerico
                            value={idTecnico}
                            setValue={setIdTecnico}
                            label="Número de empleado"
                            maxLength={7}
                            allowedChars="0-9"
                            placeholder="7120000"
                            title="Debe contener exactamente 7 dígitos numéricos"
                        />

                        {error && <div className="error">{error}</div>}
                        {success && <div className="success">{success}</div>}

                        <div className="form-buttons">
                            <button type="submit" disabled={loading}>
                                {loading ? "Buscando..." : "Buscar"}
                            </button>
                        </div>
                    </form>
                </div>
            )}


            <>
                {datosTecnico && (

                    <form onSubmit={handleModificar}>

                        {error && <div className="error">{error}</div>}
                        {success && <div className="success">{success}</div>}

                        <div className="sesion-form">
                            <p><strong>ID Técnico:</strong> {datosTecnico.id_tecnico}</p>

                            <InputSelectGenerico
                                idSeleccionado={String(datosTecnico.id_rol)}
                                setIdSeleccionado={(value) => setDatosTecnico({ ...datosTecnico, id_rol: value })}
                                label="Rol"
                                apiUrl={`consultar_roles.php`}
                                valueField="id_rol"
                                displayField="rol"
                                showDefaultOption={true}
                                defaultOptionText="Seleccione un rol"
                            />

                            <InputSelectEstados
                                idEstado={datosTecnico.id_estado}
                                setIdEstado={(value) => setDatosTecnico({ ...datosTecnico, id_estado: value })}
                                estadoActualText=""
                                idEntidad={2}
                                label="Estado del técnico"
                                apiUrl={`consultar_estados.php`}
                            />
                        </div>

                        <label>¿Desea modificar permisos?</label>
                        <div className="radio-group">
                            <label className="radio-option">
                                <input
                                    type="radio"
                                    name="modificarPermisos"
                                    value="no"
                                    checked={!modificarPermisos}
                                    onChange={() => setModificarPermisos(false)}
                                    disabled={rolCambio}
                                />
                                No
                            </label>
                            <label className="radio-option">
                                <input
                                    type="radio"
                                    name="modificarPermisos"
                                    value="si"
                                    checked={modificarPermisos}
                                    onChange={() => setModificarPermisos(true)}
                                    disabled={rolCambio}
                                />
                                Sí
                            </label>
                        </div>


                        {rolCambio && (
                            <p className="info">
                                Los permisos se actualizarán automáticamente según el nuevo rol al guardar.
                            </p>
                        )}



                        {modificarPermisos && !rolCambio && (
                            <div className="tabs-permisos">
                                <div className="tabs-header">
                                    {Array.from({ length: Math.ceil(permisosDisponibles.length / 12) }, (_, i) => (
                                        <button type="button"
                                            key={i}
                                            className={tabActiva === i ? "tab-activa" : ""}
                                            onMouseEnter={() => setTabActiva(i)} // cambia al pasar el mouse
                                        >
                                            Bloque {i + 1}
                                        </button>
                                    ))}
                                </div>

                                <table className="tabla-estandar">
                                    <thead>
                                        <tr>
                                            <th>ID Permiso</th>
                                            <th>Nombre</th>
                                            <th>Asignado</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {permisosDisponibles
                                            .slice(tabActiva * 12, tabActiva * 12 + 12)
                                            .map((permiso) => (
                                                <tr key={permiso.id_permiso}>
                                                    <td data-label="Id">{permiso.id_permiso}</td>
                                                    <td data-label="Permiso">{permiso.nombre}</td>
                                                    <td data-label="Asignado">
                                                        <input
                                                            type="checkbox"
                                                            checked={permisosSeleccionados.includes(permiso.id_permiso)}
                                                            onChange={(e) => {
                                                                if (e.target.checked) {
                                                                    setPermisosSeleccionados([...permisosSeleccionados, permiso.id_permiso]);
                                                                } else {
                                                                    setPermisosSeleccionados(
                                                                        permisosSeleccionados.filter((p) => p !== permiso.id_permiso)
                                                                    );
                                                                }
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        <div className="form-buttons">
                            <button type="submit" disabled={loading}>
                                {loading ? "Procesando..." : "Modificar"}
                            </button>
                            <button onClick={handleCancelar}>
                                Cancelar
                            </button>
                        </div>

                    </form>
                )}
            </>
        </>
    );
}

export default ModificarTecnicos;